import { styled } from '@mui/material';
import { common } from '@mui/material/colors';

import HistogramOverlay from '@/dmdrive/ui-kit/components/HistogramOverlay/HistogramOverlay';

const X_AXIS_HEIGHT = '1.4rem';

export const HistogramLoader = styled('div')({
  position: 'absolute',
  top: '-0.5rem',
  left: '-1rem',
  right: '-1rem',
  bottom: '-0.5rem',
});

export const HistogramPanel = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'stretch',
});

export const HistogramYAxis = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flexShrink: 0,
  paddingRight: '0.8rem',
  height: 100,
});

export const HistogramGraph = styled('div')({
  flexGrow: 1,
});

export const HistogramGraphOverlay = styled(HistogramOverlay)({
  height: 100,
});

export const HistogramContainer = styled('div')({
  flexGrow: 1,
  height: '100%',
});

export const HistogramContent = styled('div')({
  position: 'relative',
  width: '100%',
  height: '100%',
  '& rect': {
    strokeWidth: '0.1%',
    stroke: common.white,
  },
});

export const HistogramXAxis = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: X_AXIS_HEIGHT,
});

export const HistogramControls = styled('div')({
  flexShrink: 0,
  marginTop: '1rem',
});
